module.exports = __webpack_public_path__ + "img/bind_product.ff8fde24.png";